import React, { useState } from "react";
import { saveSubscription } from "./graph";
import { PageLayout } from "./components/PageLayout";
import { ProfileData } from "./components/ProfileData";
import {
  callLoginGraph,
  callSubscriptionActivate,
  callSubscriptionResolve,
  getAllSubscriptions,
  getSubscriptionById,
  getUserData,
  getLicense,
  cencelSubscription,
} from "./graph";
import "./styles/App.css";
import qs from "query-string";
import { useEffect } from "react";
import { Spinner, Button } from "react-bootstrap";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./styles/App.css";
import SelectTableComponent from "./components/select-table.component";

const MainContent = (props) => {
  const [data, setData] = useState("");
  const [UserData, setUserData] = useState("");
  const [totalLicensePurchased, setTotalLicensePurchased] = useState(0);
  const [userName, setUserName] = useState();
  const [usedLicense, setuseLicense] = useState(0);
  const [teamMemberCount, setTeamMemberCount] = useState(0);
  const [isUnsubscribed, setUnsubscribed] = useState(props.Unsubscribed);
  const [loadingMessage, setLoadingMessage] = useState("Loading");
  const [activationLinkExpired, setActivationLinkExpired] = useState(false);
  const [isBotInstalledInAnyTeam, setIsBotInstalledInAnyTeam] = useState(true);
  useEffect(() => {
    const queryStringObject = qs.parse(location.search);
    const isFromSafetyBot = queryStringObject.isFromSafetyBot;
    const emailId = queryStringObject.emailid || queryStringObject.emailId;
    if (isFromSafetyBot) {
      getSubscriptionDetails(emailId);
    } else {
      setLoadingMessage("Processing step 1/4.");
      getAccessToken();
    }
  }, []);

  useEffect(() => {
    setUnsubscribed(props.Unsubscribed);
  }, [props.Unsubscribed]);

  function getAccessToken() {
    callLoginGraph().then((response) => {
      setLoadingMessage("Processing step 2/4.");
      getPublisherAccessToken(response.access_token);
    });
  }

  function getPublisherAccessToken(accessToken) {
    const queryStringObject = qs.parse(location.search);
    const marketPlaceToken = queryStringObject.token;
    callSubscriptionResolve(accessToken, marketPlaceToken)
      .then((response) => {
        if (response.code === "InvalidValue") {
          setActivationLinkExpired(true);
          props.activationLinkExpire();
        } else if (
          response.subscription.saasSubscriptionStatus == "Unsubscribed"
        ) {
          setUnsubscribed(true);
        } else {
          const subscriptionDetails = {};
          subscriptionDetails;
          setLoadingMessage("Processing step 3/4.");
          callSubscriptionActivate(
            accessToken,
            response.id,
            response.planId,
            response.quantity
          ).then((resp) => {
            setLoadingMessage("Processing step 4/4.");
            props.updateSubscription(response.id);
            getSubscriptionById(accessToken, response.id).then((response) => {
              setData(response);
              saveSubscription(response).then((userData) => {
                setLoadingMessage("Loading.");
                setAllUserData(userData);
              });
            });
            setTimeout(() => {
              setLoadingMessage("Almost there.");
            }, 3000);
         });
        }
      })
      .catch((error) => console.log("callSubscriptionResolve - error", error));
  }
  const setAllUserData = (userData) => {
    if (userData == undefined || userData.userInfo == undefined) {
      setIsBotInstalledInAnyTeam(false);
      return;
    }
    if (!userData?.userInfo?.isBotInstalledInTeam) {
      setIsBotInstalledInAnyTeam(false);
      return;
    }
    var data = userData.userInfo;
    const usedLicense = data.userInfo
      ? data.userInfo.filter((item) => item.hasLicense).length
      : [];
    setuseLicense(usedLicense);
    setTotalLicensePurchased(data.totalLicensePurchased);
    setTeamMemberCount(data.teamMemberCount);
    setUserName(data.userName);
    data.availableLicense =
      data.totalLicensePurchased - usedLicense < 0
        ? 0
        : data.totalLicensePurchased - usedLicense;
    setUserData(data);
    props.updateSubscription(data.SubscriptionId);
  };

  const getSubscriptionDetails = async (emailId) => {
    await getUserData(emailId).then((userData) => {
      setAllUserData(userData);
    });
  };

  return (
    <>
      {isUnsubscribed && (
        <>
          {" "}
          <div style={{ marginLeft: "3%" }}>
            <div id="profile-div">
              <h1>Your subscription has been cancelled</h1>
              <br></br>
              <h5>
                Your Safety Check bot Premium subscription has been cancelled at
                your request and your account has been downgraded to the Free
                Plan.
              </h5>
            </div>
          </div>
        </>
      )}
      {!isUnsubscribed && (
        <div style={{ marginLeft: "3%" }}>
          <div id="profile-div">
            <div style={{ backgroundColor:"#0c2e8a", color:"#ffffff",textAlign:"center",marginRight:"9%"}}>
            <h1>Welcome to Safety Check {userName ? userName : ""}!</h1>
            </div>
            {isBotInstalledInAnyTeam && (
              <h6>
                Manage your licenses by selecting users and updating
              </h6>
            )}
          </div>
           <br />
        </div>
        
      )}
      {activationLinkExpired && (
        <>
          <br />
          <br />
          <div id="profile-div" style={{ marginLeft: "3%" }}>
            <h1>Welcome to SafetyBot!</h1>
            <hr></hr>
            <div class="alert alert-warning">
              The activation link has been expired or already been used.
            </div>
          </div>
        </>
      )}
      {!isBotInstalledInAnyTeam && (
        <>
          <hr></hr>
          <div style={{ marginLeft: "3%" }}>
            <div id="profile-div">
              <h1>To get started,</h1>
              <br></br>
              <h5>
                <ul>
                  <li>Install Safety Check bot in your team(s). </li>
                  <li>
                    Assign your purchased licences by entering Help in the
                    Safety Check chat window and clicking on the Manage Licence
                    button
                  </li>
                </ul>
              </h5>
            </div>
          </div>
        </>
      )}
      {UserData && !isUnsubscribed && isBotInstalledInAnyTeam ? (
        <SelectTableComponent UserData={UserData} />
      ) : (
        <>
          {!isUnsubscribed && isBotInstalledInAnyTeam && (
            <div
              className="border d-flex align-items-center justify-content-center"
              style={{ height: "80vh" }}
            >
              <Button variant="primary" disabled>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                &nbsp;
                {loadingMessage}...
              </Button>
            </div>
          )}
        </>
      )}
    </>
  );
};

export const productsGenerator = (quantity) => {
  const items = [];
  for (let i = 0; i < quantity; i++) {
    items.push({ id: i, name: `Item name ${i}`, price: 2100 + i });
  }
  return items;
};

export default function App() {
  const [isUnsubscribed, setIsUnsubscribed] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(0);
  const [activationLinkExpired, setActivationLinkExpired] = useState(false);
  const onCancelSubscription = () => {
    callLoginGraph().then((response) => {
      cencelSubscription(response.access_token, subscriptionId);
      setIsUnsubscribed(true);
    });
  };
  const onUpdateSubscription = (id) => {
    setSubscriptionId(id);
  };
  const onActivationLinkExpire = () => {
    setActivationLinkExpired(true);
  };
  return (
    <PageLayout cancelSubscription={onCancelSubscription}>
      <MainContent
        updateSubscription={onUpdateSubscription}
        activationLinkExpire={onActivationLinkExpire}
        activationLinkExpired={activationLinkExpired}
        Unsubscribed={isUnsubscribed}
      />
    </PageLayout>
  );
}
